"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InputSelect_styles_1 = __importDefault(require("./InputSelect.styles"));
var FormErrorMessage_1 = __importDefault(require("../FormErrorMessage/FormErrorMessage"));
var InputSelect = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, options = _a.options, id = _a.id, value = _a.value, error = _a.error, _b = _a.required, required = _b === void 0 ? false : _b, valueChanged = _a.valueChanged;
    var _c = react_1.useState(placeholder || ''), selectValue = _c[0], setSelectValue = _c[1];
    react_1.useEffect(function () {
        if (value) {
            setSelectValue(value);
        }
    }, [value]);
    return (react_1.default.createElement(InputSelect_styles_1.default, null,
        label && react_1.default.createElement("label", { htmlFor: id }, label),
        react_1.default.createElement("select", { value: selectValue, id: id, name: id, required: required, onChange: function (e) {
                setSelectValue(e.currentTarget.value);
                if (valueChanged)
                    valueChanged(id, e.currentTarget.value);
            } },
            placeholder && (react_1.default.createElement("option", { value: placeholder, disabled: true }, placeholder)),
            options.map(function (option) { return (react_1.default.createElement("option", { value: option.value, key: option.value }, option.label)); })),
        react_1.default.createElement(FormErrorMessage_1.default, null, error)));
};
exports.default = InputSelect;
